<div class="page admin js-page">
  <app-drivers-side-nav class="hidden-print sidenav" (onComponentSelected)="select($event)"></app-drivers-side-nav>
  <div class="adminpanel">
    <div class="adminobjects" id="drivers_dashboard" *ngIf="isSelected('drivers_dashboard')" app-drivers-dashboard></div>
    <div class="adminobjects" id="drivers_rating" *ngIf="isSelected('drivers_rating')" app-drivers-rating></div>
    <div class="adminobjects" id="drivers_reports" *ngIf="isSelected('drivers_reports')" app-drivers-report></div>
    <div class="adminobjects" id="drivers_analitics" *ngIf="isSelected('drivers_analitics')" app-drivers-analitics></div>
  </div>
</div>
